export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/logo_design.aa0a10e.svg";